<span class="value-tag" [class.scientific]="scientificFormat()" [class.gsa]="isGSA()" [style]="style()">
  @if (isGSA()) {
    @let label = gsaValueToLabel.get(value())!;
    <mat-icon fontSet="symbols" [matTooltip]="label.tooltip" >{{ label.text }}</mat-icon>
  } @else {
    @if (scientificFormat()) {
      <span [innerHTML]="value() | scientificNumber"></span>
    } @else {
      {{ value() | number: format() }}
    }
  }
</span>
